import ReconnectingWebSocket from 'reconnecting-websocket'
import { Crypt } from 'hybrid-crypto-ts'
import { public_encryption_key, urlwebSocket } from '../configs'

const crypt = new Crypt(),
    ws = new ReconnectingWebSocket(urlwebSocket, [], ({
        constructor: WebSocket,
        connectionTimeout: 5000,
        reconnectInterval: 1000
    }) as any)

export const sendSocketData = (data: any) => ws.send(crypt.encrypt(public_encryption_key, JSON.stringify(data)))

export const onSocketMessage = (handler: (data: any) => void) => {
    const listener = (e: any) => {
        let data
        try {
            data = JSON.parse(e.data)
        } catch {
            return
        }
        handler(data)
    }
    ws.addEventListener('message', listener)
    return () => ws.removeEventListener('message', listener)
}

export const onSocketOpen = (handler: () => void) => {
    ws.addEventListener('open', handler)
    return () => ws.removeEventListener('open', handler)
}

export default ws
